var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState, Fragment } from 'react';
import { Box, Typography, Tabs, Table, Responsive } from '@telus-uds/components-web';
import styled from 'styled-components';
import { atMobile } from '../../constants/breakpoints';
import { RichText } from '../RichText/RichText';
export var ProductSpecifications = function (_a) {
    var tabList = _a.tabList, selectedTab = _a.selectedTab;
    if (tabList.length < 1)
        return _jsx(Fragment, {});
    var _b = useState(selectedTab !== null && selectedTab !== void 0 ? selectedTab : tabList[0].id), currentTabId = _b[0], setCurrentTabId = _b[1];
    var tabs = tabList.map(function (_a) {
        var title = _a.title, id = _a.id;
        return ({ label: title, id: id });
    });
    // eslint-disable-next-line @typescript-eslint/non-nullable-type-assertion-style
    var currTab = tabList.find(function (_a) {
        var id = _a.id;
        return id === currentTabId;
    });
    var baseTokens = {
        borderRadius: 0,
        highlightBarBorderRadius: 0,
        backgroundColor: 'white',
        borderWidth: 0,
        space: 0
    };
    // on mobile, tabs should be dynamic width while on desktop they're equal width
    var variantProps = {
        itemTokens: __assign(__assign({}, baseTokens), { maxWidth: 'none' })
    };
    var data = currTab.data;
    var type = data.type, content = data.content;
    var tabContent = (_jsx(Box, { space: 3, children: _jsxs(StyledBody, { children: [type === 'list' && Array.isArray(content) && content.length > 0 && (_jsx(Table, { spacing: "compact", fullWidth: true, children: _jsx(Table.Body, { children: content.map(function (productSpec) {
                            return productSpec.label &&
                                productSpec.value && (_jsxs(Table.Row, { children: [_jsx(Table.Cell, { children: _jsxs(Typography, { variant: { bold: true }, children: [productSpec.label, ":"] }) }), _jsx(Table.Cell, { children: productSpec.value })] }, productSpec.label));
                        }) }) })), type === 'richText' && content && _jsx(RichText, { content: content })] }) }));
    return (_jsxs(_Fragment, { children: [_jsxs(Responsive, { min: "xs", max: "sm", children: [_jsx(Tabs, __assign({ value: currentTabId, onChange: setCurrentTabId, items: tabs }, variantProps, { testID: "ps-tabs" })), tabContent] }), _jsxs(Responsive, { min: "md", children: [_jsx(Tabs, { value: currentTabId, onChange: setCurrentTabId, items: tabs, testID: "ps-tabs", itemTokens: baseTokens }), tabContent] })] }));
};
// --------------------------- STYLES --------------------------- //
var StyledBody = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  @media ", " {\n    & table {\n      border: none;\n\n      & tr:first-child td {\n        box-shadow: none;\n      }\n    }\n\n    & table tr td:first-child {\n      width: 40%;\n    }\n  }\n"], ["\n  @media ", " {\n    & table {\n      border: none;\n\n      & tr:first-child td {\n        box-shadow: none;\n      }\n    }\n\n    & table tr td:first-child {\n      width: 40%;\n    }\n  }\n"])), atMobile);
var templateObject_1;
